import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {routesList, routesVacanciesList, getPage} from "../../actions/routes";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import LinkC from "../../../js/components/common/LinkC";
import AsideMenu from "../../../js/components/Vacancies/AsideMenu";
import OtherNews from "../../components/PressCenter/OtherNews";
import {newsListShort} from "../../actions/news";
import InfoBlock from "../../components/common/InfoBlock";
import {infoBlocksList} from "../../actions/infoBlocks";
import BanerAbout from "../../components/InfoPages/BanerAbout";
import SuccessForm from "../../components/Forms/SuccessForm";
import Modal from "../../components/common/Modal";
import success from "../../../images/content/constructor/success.svg";
import CheckBox from "../../components/common/CheckBox";
import {
    dogovorNumberValidator, emailValidator,
    emailValidatorText,
    innValidator,
    licNumberValidator,
    whiteSpaceValidator
} from "../../tools/form-helper";
import Input from "../../components/Constructor/Input";
import {onSubscription} from "../../actions/support";
import {feedbackForm, feedbackSubjects} from "../../actions/support";
import {checkCallbackForm} from "../../actions/callback";
import {settingsList} from "../../actions/settings";
import {settings} from "../../reducers/settings";
import {formsList} from "../../actions/forms";

class About extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            shortNews: [],
            modalEmail: false,
            modalEmailSuccess: false,
            agreementChecked: false,
            fields: {
                email: {
                    typeInput: "text",
                    placeholder: "Введите E-Mail",
                    label: "Email",
                    value: "",
                    name: "email",
                    required: true,
                    validators: [emailValidator],
                    hasError: false,
                    errorText: "Укажите корректный email",
                    dot_orange: true
                },
                firstname: {
                    typeInput: "text",
                    placeholder: "Введите Имя",
                    label: "ИМЯ",
                    value: "",
                    name: "firstname",
                    required: false,
                    hasError: false,
                    // errorText: "Укажите имя",
                    // dot_orange: true
                },
                company: {
                    typeInput: "text",
                    placeholder: "Введите название",
                    label: "СМИ",
                    value: "",
                    name: "company",
                    required: false,
                    hasError: false,
                    // errorText: "Укажите компанию",
                    // dot_orange: true
                },
            },
        };
    }

    static contextTypes = {
        selectedRegion: PropTypes.object,
        fetchBefore: PropTypes.func,
        pushHistory: PropTypes.func,
        setHeaderClassName: PropTypes.func
    };

    componentWillMount() {
        let regionId = this.context && this.context.selectedRegion.id;

        if (this.props.infoBlocks && this.props.infoBlocks.list.length === 0) {
            this.props.getInfoBlocks(regionId, 'company_main');
        }

        if (!this.props.support.aboutRoute) {
            this.props.getPage('aboutRoute', this.context.selectedRegion.id)
        }
    }

    componentDidMount() {
        if (typeof location != "undefined") {
            this.props.loadForm(location.origin + location.pathname, this.context.isB2b ? 'b2b' : '');
        }
        if (this.props.newsList && this.props.newsList.newsBasic.length === 0) {
            this.props.getNewsListShort("?list_type=basic");
        }

        if (!this.props.support.aboutRoute) {
            this.props.getPage('aboutRoute', this.context.selectedRegion.id)
        }
        this.props.formsList('mailing')
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.callbackForm.recaptchaSiteKey !== nextProps.callbackForm.recaptchaSiteKey) {
            this.createReCaptcha(nextProps.callbackForm.recaptchaSiteKey);
        }
        if ((this.props.support.subscribeSuccess !== nextProps.support.subscribeSuccess) && nextProps.support.subscribeSuccess) {
            this.setState({modalEmail: false, modalEmailSuccess: true})
        }
        if (this.props.support.subscribeError !== nextProps.support.subscribeError) {
            if (nextProps.support.subscribeError != this.props.support.subscribeError) {
                let fields = {...this.state.fields};
                if (nextProps.support.subscribeError.hasOwnProperty('captcha')) {
                    fields['email'].hasError = true
                    fields['email'].errorText = nextProps.support.subscribeError['captcha'];
                } else {
                    for (let attr in fields) {
                        fields[attr].hasError = nextProps.support.subscribeError.hasOwnProperty(attr);
                        if (nextProps.support.subscribeError.hasOwnProperty(attr)) {
                            fields[attr].errorText = nextProps.support.subscribeError[attr];
                        }
                    }
                }
            }
        }
    }

    componentDidUpdate() {
        const {shortNews} = this.state;
        const {newsList} = this.props;

        if (shortNews.length === 0 && newsList.newsBasic && newsList.newsBasic.length > 0) {
            const newsArr = newsList.newsBasic.slice(0, 3);
            this.setState({shortNews: newsArr});
        }
    }

    sortArray = (array) => {
        return array.sort((a, b) => {
            return a.id - b.id;
        })
    }
    createReCaptcha = (siteKey) => {
        const script = document.createElement("script")
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
        script.async = true;
        script.defer = true;
        document.body.appendChild(script)
    }
    onAgreementChange = (name, val) => this.setState((prev) => {
        return {
            agreementChecked: !prev.agreementChecked
        }
    })
    onFieldChange = (name, value) => {
        let fields = {...this.state.fields};

        fields[name].value = fields[name].mask ? fields[name].mask(value) : value;
        let valid = true;
        if (!value) {
            if (name !== 'firstname' && name !== 'company') {
                valid = false
            }
        }
        if (fields[name].hasOwnProperty('validators') && !!fields[name].validators) {
            fields[name].validators.forEach(function (func) {
                if (!func.call(this, fields[name].value)) {
                    valid = false;
                }
            });
        }
        fields[name].hasError = !valid;
        this.setState({fields});
    };
    onFocus = (name) => {
        return (e) => {
            this.setState({
                fields: {
                    ...this.state.fields,
                    [name]: {
                        ...this.state.fields[name],
                        hasError: null
                    }
                }
            })
        }
    };
    onBlur = (name) => {

        return (e) => {
            let field = this.state.fields[name];
            if (field.hasOwnProperty('validators')) {
                let valid = true;
                field.validators.forEach(function (func) {
                    if (!func.call(this, field.value)) {
                        valid = false;
                    }
                });
                if (name !== 'firstname' && name !== 'company') {
                    this.setState({
                        fields: {
                            ...this.state.fields,
                            [name]: {
                                ...this.state.fields[name],
                                hasError: !valid
                            }
                        }
                    });
                }
            }
        };
    };
    onSubmit = (e) => {
        e.preventDefault();

        if (this.isValid()) {
            window.grecaptcha
                .execute(this.props.callbackForm.recaptchaSiteKey)
                .then(token => {
                    const fields = {...this.state.fields}

                    this.setState({captchaError: ''})

                    let data = {
                        agreement: this.state.agreementChecked ? 1 : 0,
                        captcha: token,
                        firstname: fields.firstname.value,
                        email: fields.email.value,
                        company: fields.company.value
                    }
                    if (this.props.client.clientInfo && this.props.client.clientInfo.subs_id) data.subs_id = this.props.client.clientInfo.subs_id

                    this.props.onSubscription(data);
                })
        }
    };

    isValid = () => {
        const fields = {...this.state.fields}
        return (
            (fields["email"].value && !fields['email'].hasError) &&
            this.state.agreementChecked
        )
    }

    render() {
        const {routesVacancies, infoBlocks} = this.props;
        let {shortNews} = this.state;
        const routePressCenter = routesVacancies && routesVacancies.list.find(x => x.alias === 'press-center');
        const routeAllNews = routesVacancies && routesVacancies.list.find(x => x.alias === 'news');
        const routeVacancy = routesVacancies && routesVacancies.list.find(x => x.alias === 'vakansii');
        const companyBaner = infoBlocks && infoBlocks.list.find(x => x.type.alias === 'company_banner');

        const {regions, location} = this.props;
        let pageLink = `https://${regions.host}${location.pathname.toLowerCase()}`.replace(/(\/$)/g, "");

        const content = this.props.support && this.props.support.aboutRoute && this.props.support.aboutRoute.content
        //получаем нужный нам SEO {}
        let routeSeo = this.props.routes.list.find(x => x.sys_name === 'aboutRoute');
        const currentMetaTags = routeSeo && routeSeo.seoRegions.find(i => i.region_id === this.context.selectedRegion.id);

        const {email, firstname, company} = this.state.fields;

        const mailingForm = this.props.forms && this.props.forms.list.find(x => x.alias === 'mailing_form')

        return (
            <React.Fragment>
                <div className="page__container info-page-container">
                    <Helmet
                      htmlAttributes={{"class": "pp-mod_support_spam"}}
                      title={currentMetaTags ? currentMetaTags.meta_title : ""}
                      meta={[
                          {
                              "name": "description",
                              "content": currentMetaTags && currentMetaTags.meta_description ? currentMetaTags.meta_description : ""
                          },
                          {
                              "name": "keywords",
                              "content": currentMetaTags && currentMetaTags.meta_keywords ? currentMetaTags.meta_keywords : ""
                          }
                      ]}>
                        <link rel="canonical" href={pageLink}/>
                    </Helmet>
                    <div className="info-page-container__content">
                        <div className="info-page-container__content-left-part">
                            <h1 className="info-page-container__title">О компании</h1>
                            <div className="info-page-container__content-left-part-big">

                                <div className="about-page__slider-wrap">
                                    <InfoBlock type={'company_slider'} data={infoBlocks && infoBlocks.list}
                                               section={'company_slider'}/>
                                </div>


                                <div className="about-page__big-text-wrap">
                                    <div
                                        className="about-page__big-text mb-0"
                                        dangerouslySetInnerHTML={{__html: content}}
                                    />

                                    {/* <div className="about-page__big-text mb-24">
                                    <b>Телекоммуникационная группа Мотив</b> – ведущий инфраструктурный оператор связи в Уральском Федеральном округе.
                                    <br/>
                                    <br/>
                                    С <b>1996 года</b> компания развивает телекоммуникационную отрасль на Урале. Оператор обеспечивает высокоскоростным мобильным интернетом <b>96%</b> населения, проживающего на его лицензионной территории <b>«Большой Урал»</b>, куда входят Свердловская и Курганская области, Ханты-Мансийский и Ямало-Ненецкий автономные округа. Развитая инфраструктура охватывает более <b>1700</b> населенных пунктов. Общая территория обслуживания составляет <b>1,5 млн кв. км.</b> Об абонентах ежедневно заботятся <b>2000</b> сотрудников.
                                </div> */}

                                    {/* <div className="about-page__advantages">
                                    <div className="about-page__advantages-item">
                                        <div className="about-page__advantages-item-big-text">
                                            2,5 млн.
                                        </div>
                                        <div className="about-page__advantages-item-mini-text">
                                            * <br className="about-page__br-hide"/>  *
                                            абонентов активно пользуются связью Мотив
                                        </div>
                                    </div>

                                    <div className="about-page__advantages-item">
                                        <div className="about-page__advantages-item-big-text">
                                            96 %
                                        </div>
                                        <div className="about-page__advantages-item-mini-text">
                                            * <br className="about-page__br-hide" />  *
                                            населения Большого Урала доступен высокоскоростной 4G-интернет Мотив
                                        </div>
                                    </div>

                                    * <div className="about-page__advantages-item">
                                        <div className="about-page__advantages-item-big-text">
                                            4G
                                        </div>
                                        <div className="about-page__advantages-item-mini-text">
                                            интернет <br className="about-page__br-hide" /> сеть
                                        </div>
                                    </div> *
                                </div> */}

                                    {/* <div className="about-page__big-text mb-0">
                                    Мотив предоставляет широкие <b>цифровые возможности</b> своим абонентам, в том числе услуги мобильной, фиксированной, междугородной, международной и спутниковой связи. Оператор развивает и внедряет <b>современные цифровые сервисы и продукты:</b> интерактивное мобильное телевидение, банковское приложение, интернет-магазин, приложение для дистанционного оформления SIM-карт, технология передачи голоса в HD-качестве VoLTE и многое другое. Мотив ежедневно работает над внедрением <b>передовых технологий</b>. В 2020 году оператор первый на Урале развернул тестовую зону 5G, готовясь к запуску сети пятого поколения.
                                </div> */}
                                </div>

                                <div className="about-page__wrap-all-news">
                                    {/* блок с новостями в О компании */}
                                    {routePressCenter && routeAllNews ?
                                        <OtherNews
                                            title={'Новости'}
                                            data={shortNews}
                                            linkPageNews={routeAllNews.link}
                                            linkAllnews={true}
                                        /> :
                                        null
                                    }
                                </div>

                                <a href="https://t.me/motiv_ural" className="info-page-container__subscribe-mobile"
                                   target="_blank">
                                    <div className="info-page-container__subscribe-wrapper">
                                        <img src={`${require('../../../icons/telegram.svg')}`} alt="Подписаться"/>
                                        <span>Подписаться на новости</span>
                                    </div>
                                </a>
                                <button
                                    className="info-page-container__subscribe-mobile info-page-container__subscribe-email"
                                    onClick={() => {
                                        this.setState({modalEmail: true})
                                    }}>
                                    <div className="info-page-container__subscribe-wrapper">
                                        <img src={`${require('../../../icons/email.svg')}`} alt="Подписаться"/>
                                        <span>Подписаться на рассылку</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div className="info-page-container__content-right-part">
                            <div className="info-page-container__wrap-aside-menu motiv-vacancies">
                                <AsideMenu
                                    flag={"aboutRoute"}
                                    route={this.props.routesVacancies}
                                    customTitleMenu={'О компании'}
                                />
                            </div>

                            <a href="https://t.me/motiv_ural" className="info-page-container__subscribe"
                               target="_blank">
                                <div className="info-page-container__subscribe-wrapper">
                                    <img src={`${require('../../../icons/telegram.svg')}`} alt="Подписаться"/>
                                    <span>Подписаться на новости</span>
                                </div>
                            </a>
                            <button className="info-page-container__subscribe info-page-container__subscribe-email"
                                    onClick={() => {
                                        this.setState({modalEmail: true})
                                    }}>
                                <div className="info-page-container__subscribe-wrapper">
                                    <img src={`${require('../../../icons/email.svg')}`} alt="Подписаться"/>
                                    <span>Подписаться на рассылку</span>
                                </div>
                            </button>
                        </div>
                    </div>
                    {
                        this.state.modalEmail &&
                        <Modal className="u-modal u-modal_active modal-fullscreen modal-email" close={() => {
                            this.setState({modalEmail: false})
                        }}>
                            <div className="content">
                                <h3 className="modal-email__title">{mailingForm && mailingForm.settings.mailing_form_header}</h3>
                                <p className="modal-email__text">{mailingForm && mailingForm.settings.mailing_form_infotext}</p>
                                <div className="modal-email__form">
                                    <form onSubmit={this.onSubmit} className="vacancy-modal-form support-form">
                                        <div className="form-row form-vacancy-row form-support-row">
                                            <div
                                                className="form-vacancy-row--email form-vacancy-label-column form-support-row-item modal-email-form-inner">
                                                <Input {...email}
                                                       onChange={this.onFieldChange}
                                                       name={email.name}
                                                       onFocus={this.onFocus(email.name)}
                                                       onBlur={this.onBlur(email.name)}
                                                />
                                                <Input {...firstname}
                                                       onChange={this.onFieldChange}
                                                       name={firstname.name}
                                                       onFocus={this.onFocus(firstname.name)}
                                                       onBlur={this.onBlur(firstname.name)}
                                                />
                                                <Input {...company}
                                                       onChange={this.onFieldChange}
                                                       name={company.name}
                                                       onFocus={this.onFocus(company.name)}
                                                       onBlur={this.onBlur(company.name)}
                                                />
                                                <div
                                                    className="vacancy-modal-btn-block support-send-block modal-email-btn">
                                                    <button
                                                        onClick={this.onSubmit}
                                                        type="submit"
                                                        className={`u-btn u-btn_default u-btn_adapt_mobile-sm u-btn_responsive u-btn_adapt_default support-form-send-btn ${!this.isValid() ? 'disabled' : ''}`}>
                                                        Подписаться
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-email-agreement">
                                    <CheckBox
                                        name={'agree-feedback'}
                                        // label={(this.props.support.feedbackForm && this.props.support.feedbackForm.settings) ? this.props.support.feedbackForm.settings.feedback_form_b2b_agreement : ''}
                                        label={mailingForm && mailingForm.settings.mailing_form_agreement}
                                        value={this.state.agreementChecked}
                                        onChange={this.onAgreementChange}
                                    />
                                </div>
                                <div className="modal-email-recaptcha">
                                    Этот сайт защищен reCAPTCHA и применяются <div className="hide-br"></div>
                                    <a href="https://policies.google.com/privacy" target='_blank'>Политика
                                        конфиденциальности</a> и <a href="https://policies.google.com/terms"
                                                                    target='_blank'>Условия обслуживания</a> Google
                                </div>
                            </div>
                        </Modal>
                    }
                    {
                        this.state.modalEmailSuccess &&
                        <Modal className="u-modal u-modal_active modal-fullscreen modal-email modal-email-success"
                               close={() => {
                                   this.setState({modalEmailSuccess: false})
                               }}>
                            <div className="content">
                                <img src={`${require('../../../icons/circle-check.svg')}`}
                                     className="modal-email-success__check" alt="Успешно"/>
                                <div
                                    className="modal-email-success__title">{mailingForm && mailingForm.settings.mailing_form_success_header}</div>
                                <div
                                    className="modal-email-success__text">{mailingForm && mailingForm.settings.mailing_form_success_description}</div>
                                <div
                                    className="vacancy-modal-btn-block support-send-block modal-email-btn modal-email-success-btn">
                                    <button
                                        onClick={() => {
                                            this.setState({modalEmailSuccess: false})
                                        }}
                                        type="submit"
                                        className={"u-btn u-btn_default u-btn_adapt_mobile-sm u-btn_responsive u-btn_adapt_default support-form-send-btn"}>
                                        Хорошо
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    }
                </div>
                {!!companyBaner && routeVacancy ?
                  <BanerAbout companyBaner={companyBaner}/>
                  : null}
                <div className="page__container info-page-container">
                    <div className="info-page-container__content">
                        <div className="info-page-container__content-left-part">
                            <div className="info-page-container__content-left-part-big">
                                <div className="about-page__wrap-contacts">
                                    <div className="about-page__panel-all-news">
                                        <h3 className="about-page__title-all-news">
                                            Контакты
                                        </h3>
                                    </div>

                                    <div className="about-page__contacts-all">
                                        <div className="about-page__contacts-item">
                                            <LinkC to={"/for-subscribers"} className={""}>
                                                <div className="about-page__contacts-item-content">
                                                    <img
                                                      className="about-page__contacts-item-img"
                                                      src={require("../../../images/content/info-pages/subscriber.svg")}
                                                      alt="Контакты"
                                                    />
                                                    <div className="about-page__contacts-item-title">
                                                        Для абонентов
                                                    </div>
                                                </div>
                                            </LinkC>
                                        </div>
                                        <div className="about-page__contacts-item">
                                            <LinkC to={"/for-press"} className={""}>
                                                <div className="about-page__contacts-item-content">
                                                    <img
                                                      className="about-page__contacts-item-img"
                                                      src={require("../../../images/content/info-pages/press.svg")}
                                                      alt="Для прессы"
                                                    />
                                                    <div className="about-page__contacts-item-title">
                                                        Для прессы
                                                    </div>
                                                </div>
                                            </LinkC>
                                        </div>
                                        <div className="about-page__contacts-item">
                                            <LinkC to={"/for-partners"} className={""}>
                                                <div className="about-page__contacts-item-content">
                                                    <img
                                                      className="about-page__contacts-item-img"
                                                      src={require("../../../images/content/info-pages/hands.svg")}
                                                      alt="Для партнеров"
                                                    />
                                                    <div className="about-page__contacts-item-title">
                                                        Для партнеров
                                                    </div>
                                                </div>
                                            </LinkC>
                                        </div>
                                        <div className="about-page__contacts-item">
                                            <LinkC to={"/for-buisness"} className={""}>
                                                <div className="about-page__contacts-item-content">
                                                    <img
                                                      className="about-page__contacts-item-img"
                                                      src={require("../../../images/content/info-pages/portfolio.svg")}
                                                      alt="Для корпоративных клиентов"
                                                    />
                                                    <div className="about-page__contacts-item-title">
                                                        Для бизнеса
                                                    </div>
                                                </div>
                                            </LinkC>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default connect(
    state => ({
        routes: state.routes,
        routesVacancies: state.routesVacancies,
        regions: state.regions,
        newsList: state.news || [],
        infoBlocks: state.infoBlocks || [],
        support: state.support,
        callbackForm: state.callbackForm,
        client: state.client,
        settings: state.settings,
        forms: state.forms
    }),
    (dispatch) => {
        return {
            formsList: (group) => dispatch(formsList(group)),
            settingsList: (name) => dispatch(checkCallbackForm(name)),
            loadForm: (url, businessLine) => dispatch(checkCallbackForm(url, businessLine)),
            getRoutes: () => dispatch(routesList()),
            getNewsListShort: (listType) => dispatch(newsListShort(listType)),
            getInfoBlocks: (regionId, group) => dispatch(infoBlocksList(regionId, group)),
            getPage: (page, region) => dispatch(getPage(page, region)),
            onSubscription: (data) => dispatch(onSubscription(data)),
            onFeedbackForm: () => dispatch(feedbackForm()),
            getFeedbackSubjects: () => dispatch(feedbackSubjects()),
        }
    }
)(About);

/**
 * func - method must be called on page preload
 * args - arguments for 'func' method
 * args.id - id/slug etc. - unique object's field
 * args.regionId - must be true, if it need
 * object - path to check object on page preload
 * checkField - unique object field for check, must be null for arrays
 * main - bool - main object on current page. fetchBefore (url, id) - id/slug etc for this object
 * withRegions - this flag add regionId as first argument
 * @type {*[]}
 */
export const AboutRequests = [
    {
        func: 'getRoutes',
        args: [],
        object: 'routes.list',
        checkField: null,
        main: false,
        withRegion: false,
        objectReceived: false,
    },
    {
        func: 'getInfoBlocks',
        args: ['company_main'],
        object: 'infoBlocks.list',
        checkField: null,
        main: false,
        withRegion: true,
        objectReceived: false,
        alias: [
            {type: "company_slider"},
            {type: "company_banner"},
        ]
    },
    {
        func: 'getNewsListShort',
        args: ['?list_type=basic'],
        object: 'newsList.newsBasic',
        checkField: null,
        main: false,
        withRegion: false,
        objectReceived: false,
    }
];